import { render, staticRenderFns } from "./WithdrawItemsDialog.vue?vue&type=template&id=654e9ec6&scoped=true&"
import script from "./WithdrawItemsDialog.vue?vue&type=script&lang=ts&"
export * from "./WithdrawItemsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./WithdrawItemsDialog.vue?vue&type=style&index=0&id=654e9ec6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654e9ec6",
  null
  
)

export default component.exports